import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=60b69b48&scoped=true"
import script from "./MailList.vue?vue&type=script&setup=true&lang=js"
export * from "./MailList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MailList.vue?vue&type=style&index=0&id=60b69b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b69b48",
  null
  
)

export default component.exports